import styled from '@emotion/styled';

interface TableHasProfilePictureProps {
  data?: Record<string, any>;
  dataKey?: string;
}

const TableHasProfilePicture: React.FC<TableHasProfilePictureProps> = ({
  data,
  dataKey,
}) => {
  const label = data && data[dataKey ?? ''];

  return (
    <Container>
      {!!label ? <Uploaded>Uploaded</Uploaded> : <NoImage>No Image</NoImage>}
    </Container>
  );
};

export default TableHasProfilePicture;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;

const Uploaded = styled.span`
  color: #00b73f;
  border: 1px solid rgba(221, 221, 221, 1);
  background-color: rgba(0, 183, 63, 0.05);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;

const NoImage = styled.span`
  color: #757575;
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;
